import styled from 'styled-components'

export const MotiveContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.grey4};
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  margin-bottom: 12px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey8};
  }
`

export const InfoText = styled.div`
  margin: 0;

  &:not(:only-child):not(:last-child) {
    margin-bottom: 8px;
  }
`

export const TitleContainer = styled.div`
  justify-content: space-between;
  display: flex;
  flex: auto;

  ${({ hasTexts }) => hasTexts && `margin-bottom: 14px;`}
`
